import React from "react";

const PopupMessage = ({ visible, title = "Notice", message = "", onClose, type = "error", showButton = true, showSpinner = false }) => {
  if (!visible) return null;

  return (
    <div className="popup-overlay" role="dialog" aria-modal="true">
      <div className="popup-message">
        <div className={`popup-title popup-${type}`}>{title}</div>
        <div className="popup-text">
          {showSpinner && <span className="spinner"></span>}
          {message}
        </div>
        {showButton && (
          <div className="popup-buttons">
            <button type="button" className="popup-btn" onClick={onClose}>
              OK
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupMessage;
